import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks/useCanAccess';
import { PayorManagement } from 'pages/payors';

export const PayorManagementRoute = () => {
  const { isAdmin, canAccess, isExpired } = useCanAccess('payors');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin || canAccess ? (
    <PayorManagement />
  ) : (
    <Unauthorized />
  );
};
